import {h, Fragment} from "preact"
import { useAppStateSelector, useSelectedFiltersCount, useSort, pick, useSizeOptions } from "@nosto/preact"
import { sortOptions,defaultConfig, sizes } from "../config"
import Icon from "./elements/Icon"
import Select from "./elements/Select"
import { toggleButtonId } from "./Sidebar"
import SortDropdown from "./elements/SortDropdown"

function ToggleMobileSidebarButton({ selectedFiltersCount, className }) {
    return (
        <label
            for={toggleButtonId}
            className={`ns-act-btn ns-act-btn-light ns-filters ns-d-inline-flex ns-text-align-center ns-align-items-center ${className}`}
        >
            {/* <Icon name="filter" /> */}
            <span>Filters</span>
            <svg width="1em" height="1em" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M4 9L12 17L20 9" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
            </svg>
            {/* {selectedFiltersCount > 0 && (
                <span className="ns-total-count ns-d-inline-block ns-text-align-center ns-font-3 ns-font-bold ns-color-white ns-background-primary ns-ml-1">
                    {selectedFiltersCount}
                </span>
            )} */}
        </label>
    )
}

export default function Toolbar({isMobile}) {
    const { loading, query, response, pageType } = useAppStateSelector(state =>
        pick(state, "loading", "query", "response", "pageType")
    )
    const { activeSort, setSort } = useSort(sortOptions)
    const selectedFiltersCount = useSelectedFiltersCount()

    const handleSortChange = event => {
        setSort(event.target.value)
    }

    const docCount = response.products?.total ?? 0

    const totalSummary = pageType === "category" ? `${docCount} products` : `'${query.query}' - ${docCount} results`

    const options = sortOptions.map(o => ({ value: o.id, label: o.value.name }))

    const { total, to } = useSizeOptions(sizes, defaultConfig.serpSize)

    return (
        <div
            // ns-flex-column ns-flex-md-row ns-pt-o ns-pr-2 ns-pb-1 ns-pl-2
            class="ns-header-controls ns-d-flex ns-d-none ns-d-md-flex  ns-flex-wrap align-center ns-justify-content-between"
            // style={loading ? "opacity: 0.3; justify-content: end !important;" : ""}
        >
            {/* {!loading && (
                <span
                    class="ns-d-inline ns-text-align-center ns-order-3 ns-d-md-block ns-order-md-first ns-align-self-md-center ns-color-black"
                    data-nosto-element="totalResults"
                >
                    {totalSummary}
                </span>
            )} */}
            {/* ns-flex-wrap ns-justify-content-between ns-d-md-block ns-mb-4 */}
            <div class="ns-d-flex nos-w-100">
                <ToggleMobileSidebarButton
                    selectedFiltersCount={selectedFiltersCount}
                />
                {!isMobile && (<div class="collection-facets__item facets__product-count">
                    <div class="facets__divider small-hide ">&nbsp;</div>
                    <div class="collection-facets__status" role="status">
                        <span>Showing</span><span class="collection-facets__product-count" id="ProductCount">
                            <span class="product-count-of-all">{total < to ? total : to}</span> of {total} products
                        </span>
                    </div>
                </div>)}
                
                {/* <Select
                    value={activeSort}
                    onChange={e => handleSortChange(e)}
                    className="ns-selection-dropdown-sort-menu"
                    options={options}
                    label={"Sort by"}
                /> */}
            </div>
            <SortDropdown />
            {isMobile && (<div class="collection-facets__item facets__product-count">
                    <div class="facets__divider small-hide ">&nbsp;</div>
                    <div class="collection-facets__status" role="status">
                        <span>Showing</span><span class="collection-facets__product-count" id="ProductCount">
                            <span class="product-count-of-all">{total < to ? total : to}</span> of {total} products
                        </span>
                    </div>
            </div>)}
        </div>
    )
}
